<woa-modal-page-layout [title]="'woa.heading.deals.dealCode'">
    <woa-applied-deals-panel [divided]="showCode()" [hideMessage]="ordering()"
                             (dealRemoved)="dealRemoved()"></woa-applied-deals-panel>
    <woa-form (onSubmit)="applyDealCode()">
        @if (showCode()) {
            <woa-text-field [(ngModel)]="dealCode" name="dealCode"
                            [label]="'woa.label.deals.dealCode'" required [maxlength]="'255'" [readOnly]="ordering()"
                            [inputMode]="codeInputMode()" [autocomplete]="'new-password'"></woa-text-field>
        }
    </woa-form>
    @if (result()?.msg) {
        <woa-footer-message [text]="result()?.msg"></woa-footer-message>
    }
    @if (dealModel.dealLimitReached()) {
        <woa-button woa-page-footer-control [label]="'woa.button.common.close'"
                    (onActivate)="dismiss()"></woa-button>
    }
    @if (showCode()) {
        <woa-button woa-page-footer-control [label]="'woa.button.deals.applyDealCode'"
                    (onActivate)="form().submit()"></woa-button>
    }
    @if (result()?.resultCode === DealStatus.IMMEDIATE) {
        <woa-button woa-page-footer-control
                    [label]="'woa.button.common.ok'" [prominence]="ButtonProminence.LOW"
                    (onActivate)="dismiss(result())"></woa-button>
    }
</woa-modal-page-layout>
